export const sectionDisplayNames = {
  basics: "The Basics",
  family: "Family",
  guardian: "Guardians",
  distribution: "Distribution",
  executor: "Executor",
  poaAttorney: "POA for Property",
  poaCare: "POA for Care",
};
